<template>
  <v-card
    class="c-slide-control-next"
    color="transparent"
    flat
    ripple
    @click.stop="handleClick"
  >
    <v-btn fab depressed small color="grey lighten-2">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$emit('next')
    },
  },
}
</script>

<style lang="scss">
.c-slide-control-next {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  cursor: pointer;
  position: relative;
}
</style>
